import React, { useState, useEffect, useContext } from "react";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import { makeStyles } from "@mui/styles";
import FlexComponent from "components/MBM/Flex/FlexComponent";
import postPageVisit from "services/LogService";

const useStyles = makeStyles((theme) => ({
  cardbody: {
    padding: 0,
  },
  card: {
    padding: 0,
    marginTop: 10,
    marginBottom: 10,
  },
}));

function Flex() {
  const classes = useStyles();
  const [redirState, setRedirState] = useState(false);
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage, selectedNodesInfo } = appContext;

  useEffect(() => {
    setPage('flex');
    postPageVisit('flex');
  }, []);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/flex",
      }}
    />
  );
  return (
    <ErrorBoundary
      onReset={() => setRedirState(true)}
      FallbackComponent={ErrorFallbackDialog}
      page={"geb"}
    >
      <FlexComponent />
      {redirecting}
    </ErrorBoundary>
  );
}

export default Flex;
